export const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "2-digit",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
});

export const formatDate = (seconds: number | undefined): string => {
    if (!seconds) {
        return "-";
    }
    return dateTimeFormat.format(seconds * 1000).replace(",", "");
};
